module.exports = __webpack_public_path__ + "media/img/loading-bbdac9cda255c54bfd809110aff87898.gif";